import React from 'react';
import { Link } from 'react-router-dom';
import './CourseCard.css';

function CourseCard({ course }) {
  return (
    <Link to={`/course/${course.id}`} className="course-card-link">
      <div className="course-card">
        <div className="course-image">
          <img src={course.image} alt={course.title} />
        </div>
        <div className="course-info">
          <h3 className="course-title">{course.title}</h3>
          <p className="course-category">{course.category}</p>
          <div className="course-instructor">
            <span>教授老师: </span>
            <span>{course.instructor}</span>
          </div>
          <div className="course-bottom">
            <div className="course-price">
              <span className="current-price">¥{course.price}</span>
              {course.originalPrice && (
                <span className="original-price">¥{course.originalPrice}</span>
              )}
            </div>
            <div className="course-stats">
              <span className="enroll-count">{course.enrollCount}人</span>
              <button className="enroll-btn-course" onClick={(e) => e.preventDefault()}>购买课</button>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default CourseCard; 